import React, { useEffect } from "react";
import "./MasterViewStyle.scss";
import Cards from "./Cards/Cards";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Skeleton } from "primereact/skeleton";
import { useDispatch, useSelector } from "react-redux";
import { fetchMasterCardsData } from "../../Store/Masters/MastersAction";
import {
  getCardsData,
  getIsCardDataError,
  getIsCardDataLoading,
} from "../../Store/Masters/MastersSelectors";
import NoRecordFound from "../../Shared/Component/NoRecordFound/NoRecordFound";
import { useTranslation } from "react-i18next";

const MastersView = () => {
  const dispatch = useDispatch();
  const isCardLoading = useSelector(getIsCardDataLoading);
  const cardsData = useSelector(getCardsData);
  const isCardError = useSelector(getIsCardDataError);
  const { t } = useTranslation("master");
  useEffect(() => {
    const userRole = sessionStorage.getItem("userRole");
    dispatch(fetchMasterCardsData());
    console.log("userRole",userRole);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isCardLoading) {
    return <Skeleton size="5rem"></Skeleton>;
  }
  if (isCardError) {
    return <NoRecordFound />;
  }
  return (
    <div>
      <Accordion multiple activeIndex={[0]}>
        {cardsData && cardsData.length > 0 ? (
          cardsData.map((cardType) => {
            return (
              <AccordionTab
                key={cardType.masterCategory}
                header={
                  <div className="flex align-items-center line-height-2 justify-content-between">
                    <div className="vertical-align-middle text-blue-900">
                      {t(cardType.masterCategory)}
                    </div>
                  </div>
                }
              >
                <div className="cardsContent">
                  {cardType && cardType.data && cardType.data.length > 0
                    ? cardType.data.map((item) => (
                        <Cards content={item} key={item.id} />
                      ))
                    : null}
                </div>
              </AccordionTab>
            );
          })
        ) : (
          <NoRecordFound />
        )}
      </Accordion>
    </div>
  );
};

export default MastersView;
